<script lang="ts">
    import Logo from "./otto-ai.svg";

    let { message }: { message: string; animate?: boolean } = $props();
</script>

<section data-testid="message-assistant" class="bot-message">
    <img class="otto-tag" src={Logo} alt="OTTO AI Logo" height="19" />
    <p class="bot-text">{message}</p>
</section>

<style lang="scss">
    @use "@otto-ec/design-tokens/tokens";

    .otto-tag {
      align-self: start;
    }

    .bot-message {
      display: flex;
      flex-direction: column;
      gap: tokens.$oc-semantic-spacing-50;
    }

    .bot-text {
      margin: 0;
    }
</style>
